import bgPurpleCard from '../images/bg-purple-card.png';
import bgBlackCard from '../images/bg-black-card.png';
import watchIcon from '../images/watch-icon.png';

const styles = {
  container: {
    display: 'flex',
    flexDirection: { xs: 'column', md: 'row' },
    gap: 3,
    maxWidth: '1080px',
    margin: '0 auto',
  },
  cardWrapper: {
    flex: 1,
  },
  commonCard: {
    position: 'relative',
    borderRadius: 2,
    overflow: 'visible',
    height: { xs: 'auto', md: '545px' },
    width: '100%',
    p: { xs: 3, md: '50px' },
    display: 'flex',
    flexDirection: 'column',
    gap: { xs: 3, md: '40px' },
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
  },
  partTimeCard: {
    backgroundColor: 'kit.background.middlepurple',
    border: '1px solid #D8CAFF',
    boxShadow: '0px 3px 20px 0px rgba(0,0,0,0.15)',
    backgroundImage: `url(${bgPurpleCard})`,
  },
  fullTimeCard: {
    backgroundColor: 'kit.background.white',
    border: '1px solid #0F0F0F',
    overflow: 'hidden',
    backgroundImage: `url(${bgBlackCard})`,
  },
  headerWrapper: {
    display: 'flex',
    flexDirection: { xs: 'column', md: 'row' },
    justifyContent: { md: 'space-between' },
    alignItems: { xs: 'flex-start', md: 'flex-start' },
    gap: { xs: 2, md: 0 },
  },
  badge: {
    position: { xs: 'static', md: 'absolute' },
    top: { md: 22 },
    right: { md: 22 },
    backgroundColor: 'kit.background.purple',
    borderRadius: 1,
    px: 1,
    py: 0.5,
    alignSelf: { xs: 'flex-start', md: 'auto' },
  },
  badgeText: {
    fontFamily: 'Inter',
    fontSize: 12,
    color: 'kit.text.mainInverse',
    letterSpacing: '0.36px',
    lineHeight: 1.3,
  },
  titleWrapper: {
    zIndex: 2,
  },
  title: {
    fontFamily: 'RF Rostin',
    fontSize: '40px',
    fontWeight: 700,
    letterSpacing: '-2.8px',
    textTransform: 'uppercase',
    lineHeight: 1.2,
    mb: 1,
  },
  partTimeTitle: {
    color: 'kit.text.h',
  },
  fullTimeTitle: {
    color: 'kit.text.main',
  },
  subtitle: {
    fontFamily: 'Inter',
    fontSize: 18,
    color: 'kit.text.secondary',
    lineHeight: 1.45,
  },
  commonButton: {
    borderRadius: '20px',
    textTransform: 'uppercase',
    fontFamily: 'RF Rostin',
    fontWeight: 700,
    fontSize: 16,
    lineHeight: 1.2,
    letterSpacing: '-0.16px',
  },
  partTimeButton: {
    zIndex: 2,
  },
  fullTimeButton: {
    border: '2px solid #0F0F0F',
    color: 'kit.text.main',
    '&:hover': {
      backgroundColor: 'kit.background.gray',
      border: '2px solid #0F0F0F',
    },
  },
  featuresList: {
    display: 'flex',
    flexDirection: 'column',
    gap: 2,
    zIndex: 2,
  },
  featureItem: {
    display: 'flex',
    alignItems: 'center',
    gap: 2,
  },
  featureIcon: {
    flexShrink: 0,
  },
  featureText: {
    fontFamily: 'Inter',
    fontSize: 18,
    color: 'kit.text.main',
    lineHeight: 1.45,
  },
  watchIcon: {
    position: 'absolute',
    bottom: { xs: -35, md: -50 },
    right: { xs: -30, md: -40 },
    width: { xs: 123, md: 174 },
    height: { xs: 123, md: 174 },
    backgroundImage: `url(${watchIcon})`,
    backgroundSize: 'contain',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    zIndex: 2,
  },
};

export default styles;
